/* eslint-disable no-debugger */
/* eslint-disable sonarjs/no-identical-functions */
/* cspell: disable*/
import React from 'react';
import './registerUserData.less';
import { Theme } from '@theme';
import { WithCoreProps, TranslationProps, CoreHelper, ActionMetaService } from 'ff-shared-components-core';
import {
	Button,
	TitleContainer,
	InputField,
	RadioButton,
	FileField,
	TemporaryFile,
	FileUploadType,
	modalOpen,
	BuildOkInfoModal,
	Modal,
	BuildCustomMessageGenericErrorModal,
	FileAction,
	PageScreen,
	FieldsFormContainer,
} from '@shared/components';
import { Formik, Form, FormikValues, Field } from 'formik';
import { userDataSchema } from '@components';
import { Popup } from 'semantic-ui-react';
import { bindActionCreators, Dispatch } from 'redux';
import {
	saveUserData,
	updateUserData,
	fetchUploadFileExecutionRequest,
	UserData,
	StoreState,
	getUsersData,
	RegisterFileUploadType,
} from '@store';
import { connect } from 'react-redux';
import { ProcessFlowState, getProcessFlow } from '@shared/processFlow';
import { EnrollmentTypes } from '@api/ff-shared-services-api';
import { FileUploadConfig } from '@config';
import { v4 as uuidv4 } from 'uuid';

interface RegisterUserDataState {
	idDocumentNumber: string;
	shortName: string;
	email: string;
	phonePrefix: string;
	phone: number | string;
	idDocumentType: EnrollmentTypes.UserIdentificationDocumentType | undefined;
	profileAccess: EnrollmentTypes.UserProfile | undefined;
	identificationDocumentFile: RegisterFileUploadType;
}

interface RegisterUserDataProps {
	isEditMode?: boolean;
	userData?: UserData | null | undefined;
	onClickNext(): void;
	onClickBack(data: any): void;
	onClickCancel?: () => void;
}

interface RegisterUserDataInjectedProps extends TranslationProps {
	theme: Theme;
	processFlow: ProcessFlowState;
	usersDataList: UserData[] | undefined;
	saveUserData?: (userData: UserData) => void;
	updateUserData?: (userData: UserData) => void;
	fetchUploadFileExecutionRequest: (fileData: FileUploadType, metaData?: ActionMetaService) => void;
	removeUploadFileExecution: (currentStep: number) => void;
	modalOpen: (modal: Modal) => void;
}

type Props = RegisterUserDataProps & RegisterUserDataInjectedProps;

class RegisterUserDataScreen extends React.PureComponent<Props, RegisterUserDataState> {
	userInternalId: string | undefined = undefined;

	// eslint-disable-next-line sonarjs/cognitive-complexity
	public constructor(props: Props) {
		super(props);

		const { userData, isEditMode } = this.props;

		//debugger;
		this.userInternalId = isEditMode && userData && userData.id ? userData.id : undefined;

		this.state = {
			idDocumentType:
				isEditMode && userData ? userData.idDocumentType : EnrollmentTypes.UserIdentificationDocumentType.CC,
			idDocumentNumber: isEditMode && userData ? userData.idDocumentNumber : '',
			shortName: isEditMode && userData ? userData.shortName : '',
			phonePrefix: isEditMode && userData ? userData.phonePrefix : '+351',
			email: isEditMode && userData ? userData.email : '',
			phone: isEditMode && userData ? userData.phone : '',
			profileAccess: isEditMode && userData ? userData.profileAccess : undefined,
			identificationDocumentFile: {
				id: isEditMode && userData && userData.identificationDocument ? userData.identificationDocument.id : '',
				fileName:
					isEditMode && userData && userData.identificationDocument
						? userData.identificationDocument.fileName
						: '',
				inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
			},
		};

		// this.state = {
		// 	nif: '',
		// 	shortName: '',
		// 	phonePrefix: '+351',
		// 	email: '',
		// 	phone: '',
		// 	selectedRadio: '',
		// 	profileAccess: undefined,
		// 	identificationDocumentName: '',
		// };

		window.scrollTo(0, 0);
	}

	/**
	 * Method handle the response from file chooser component and sets value to formik setFielValue()
	 *
	 * @memberof RegisterUserDataScreen
	 */

	private handleFileChange = (
		file: TemporaryFile,
		action: FileAction,
		currentFile: FileUploadType,
		fieldName: string,
		setFormikInputValue: (field: string, value: FileUploadType, shouldValidate?: boolean) => void
	): void => {
		if (action === FileAction.Add) {
			if (!file.error) {
				currentFile = {
					id: file.id,
					name: file.file.name,
					type: file.file.type,
					base64File: file.base64File,
					inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CC.toString(),
				};
			}
		} else if (action === FileAction.Remove) {
			currentFile = {
				id: '',
				name: '',
				type: '',
				base64File: '',
			};
		}

		// Only has 1 file
		setFormikInputValue(fieldName, currentFile, false);
	};

	// public handleChange = (
	// 	saveFile: TemporaryFile,
	// 	fieldName: string,
	// 	setFormikInputValue: (field: string, value: FileUploadType, shouldValidate?: boolean) => void
	// ): void => {
	// 	let file: FileUploadType = { id: '', name: '' };
	// 	if (saveFile && !saveFile.error) {
	// 		file = {
	// 			id: saveFile.id,
	// 			name: saveFile.file.name,
	// 			type: saveFile.file.type,
	// 			base64File: saveFile.base64File,
	// 			inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CC.toString(),
	// 		};
	// 	}

	// 	const identificationFile = file;
	// 	const { type, base64File } = identificationFile;

	// 	if (type && base64File) {
	// 		// Only has 1 file
	// 		setFormikInputValue(fieldName, identificationFile, false);
	// 	}
	// };

	// eslint-disable-next-line sonarjs/cognitive-complexity
	public render(): JSX.Element {
		const {
			onClickNext,
			onClickBack,
			onClickCancel,
			t,
			theme,
			saveUserData,
			fetchUploadFileExecutionRequest,
			usersDataList,
			modalOpen,
			isEditMode,
			updateUserData,
		} = this.props;
		// const { shortName, phonePrefix, email, phone, profileAccess, identificationDocumentName } = this.state;
		const {
			idDocumentType,
			idDocumentNumber,
			shortName,
			phonePrefix,
			email,
			phone,
			profileAccess,
			identificationDocumentFile,
		} = this.state;

		const signer = t<string>('radioButtons.userData.signer');
		const operator = t<string>('radioButtons.userData.operator');

		return (
			// <div id="page-register-user-data" className="page-register-user-data">
			// 	<div className="registerPharmacy-container register-user-data-container top-88px">

			<PageScreen name="page-register-user-data">
				<div className="title bottom-88px">
					<span>{t<string>('titles.registerPharmacy.userData.step1')}</span>
				</div>

				<Formik
					validationSchema={userDataSchema({ t })}
					initialValues={{
						idDocumentType: idDocumentType,
						idDocumentNumber: idDocumentNumber,
						shortName: shortName,
						phone: phone,
						email: email,
						phonePrefix: phonePrefix,
						profileAccess: profileAccess,
						identificationFile: {
							id: identificationDocumentFile ? identificationDocumentFile.id : '',
							name: identificationDocumentFile ? identificationDocumentFile.fileName : '',
							// type: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
							type: '',
							base64File: '',
						},
					}}
					onSubmit={(values: any, { setSubmitting }): void => {
						const {
							// nif,
							idDocumentType,
							idDocumentNumber,
							shortName,
							email,
							phonePrefix,
							phone,
							profileAccess,
							identificationFile,
						} = values;

						const userData: UserData = {
							id: this.userInternalId,
							idDocumentType,
							idDocumentNumber: idDocumentNumber as string,
							shortName,
							email,
							phonePrefix,
							phone,
							profileAccess,
							identificationDocument: {
								id: identificationFile.id,
								fileName: identificationFile.name,
								inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
							},
						};

						//debugger;

						// const userData: UserData = {
						// 	id: nif,
						// 	shortName: shortName,
						// 	email: email,
						// 	phonePrefix: phonePrefix,
						// 	phone: phone,
						// 	profileAccess: profileAccess,
						// 	identificationDocument: {
						// 		id: '',
						// 		fileName: identificationFile.name,
						// 		inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
						// 	},
						// };

						// Falta guardar id do File no userData , falta serviço para guardar file do user.
						const hasFileData = identificationFile.type && identificationFile.base64File ? true : false;

						//debugger;
						if (isEditMode) {
							if (hasFileData) {
								//debugger;
								fetchUploadFileExecutionRequest(identificationFile, {
									successHandler: (fileId: string) => {
										//debugger;
										if (fileId) {
											userData.identificationDocument.id = fileId;
										}

										updateUserData && updateUserData(userData);

										onClickNext();
									},
								});
							} else {
								// If is in EditMode and file doens't changed, base64 is empty here.
								updateUserData && updateUserData(userData);
							}

							onClickNext();
						} else if (hasFileData) {
							/* MOCK_DATA - START */
							// saveUserData &&
							// 	saveUserData({
							// 		id: '123456789',
							// 		shortName: 'Nelson Barbosa',
							// 		email: 'werwerwe@hotmail.com',
							// 		phonePrefix: '+351',
							// 		phone: 876789098,
							// 		idDocumentType: EnrollmentTypes.UserProfile.OPERATOR,
							// 		identificationDocument: {
							// 			id: 'ecd5bbe0-5a6f-4cd0-a651-6fd13077222c',
							// 			fileName: 'cp  2019-11-07.pdf',
							// 			inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
							// 		},
							// 	});
							/* MOCK_DATA - END */

							fetchUploadFileExecutionRequest(identificationFile, {
								successHandler: (fileId: string) => {
									if (fileId) {
										/* Create unique identifier on user creation */
										userData.id = uuidv4();
										userData.identificationDocument.id = fileId;
									}

									const userExists =
										usersDataList &&
										usersDataList.find(u => u.idDocumentNumber === userData.idDocumentNumber);
									if (userExists) {
										// show modal
										modalOpen(
											BuildCustomMessageGenericErrorModal(
												'pt',
												t('screens.register.newUserExists')
											)
										);
										return;
									}

									saveUserData && saveUserData(userData);

									onClickNext();
								},
							});
						}

						setSubmitting(false);
					}}
				>
					{({
						isSubmitting,
						handleChange,
						values,
						getFieldMeta,
						handleSubmit,
						setFieldValue,
					}): FormikValues => (
						<Form onSubmit={handleSubmit}>
							<FieldsFormContainer>
								{/* <div className="default-page-container"> */}
								<TitleContainer
									text={t('titleContainer.registerPharmacy.userData')}
									content={(): React.ReactNode => (
										<TitleContainer
											text={t('Tipo de documento de identificação')}
											content={(): React.ReactNode => (
												<div className="ds-form-radio-horizontal radios-4-in-line">
													<div>
														<Field
															component={RadioButton}
															id={CoreHelper.guid()}
															name="idDocumentType"
															labelText={'Cartão de cidadão'}
															inputFieldLabel=""
															value={EnrollmentTypes.UserIdentificationDocumentType.CC}
															isChecked={
																idDocumentType ===
																EnrollmentTypes.UserIdentificationDocumentType.CC
															}
															onChange={(
																e: React.ChangeEvent<HTMLInputElement>
															): void => {
																this.setState({
																	idDocumentType:
																		EnrollmentTypes.UserIdentificationDocumentType[
																			e.target.value
																		],
																});
																setFieldValue(
																	'idDocumentType',
																	EnrollmentTypes.UserIdentificationDocumentType[
																		e.target.value
																	],
																	false
																);
																// handleChange(
																// 	(values.idDocumentType =
																// 		EnrollmentTypes.UserIdentificationDocumentType[
																// 			e.target.value
																// 		])
																// );
															}}
															hasError={getFieldMeta('idDocumentType').error}
															errorMessage={getFieldMeta('idDocumentType').error}
														/>
													</div>

													<div>
														<Field
															component={RadioButton}
															id={CoreHelper.guid()}
															name="idDocumentType"
															labelText={'BI'}
															inputFieldLabel=""
															value={EnrollmentTypes.UserIdentificationDocumentType.BI}
															isChecked={
																idDocumentType ===
																EnrollmentTypes.UserIdentificationDocumentType.BI
															}
															onChange={(
																e: React.ChangeEvent<HTMLInputElement>
															): void => {
																this.setState({
																	idDocumentType:
																		EnrollmentTypes.UserIdentificationDocumentType[
																			e.target.value
																		],
																});
																setFieldValue(
																	'idDocumentType',
																	EnrollmentTypes.UserIdentificationDocumentType[
																		e.target.value
																	],
																	false
																);
																// handleChange(
																// 	(values.idDocumentType =
																// 		EnrollmentTypes.UserIdentificationDocumentType[
																// 			e.target.value
																// 		])
																// );
															}}
															hasError={getFieldMeta('idDocumentType').error}
															errorMessage={getFieldMeta('idDocumentType').error}
														/>
													</div>

													<div>
														<Field
															component={RadioButton}
															id={CoreHelper.guid()}
															name="idDocumentType"
															labelText={'Passaporte'}
															inputFieldLabel=""
															value={
																EnrollmentTypes.UserIdentificationDocumentType.PASSPORT
															}
															isChecked={
																idDocumentType ===
																EnrollmentTypes.UserIdentificationDocumentType.PASSPORT
															}
															onChange={(
																e: React.ChangeEvent<HTMLInputElement>
															): void => {
																this.setState({
																	idDocumentType:
																		EnrollmentTypes.UserIdentificationDocumentType[
																			e.target.value
																		],
																});
																setFieldValue(
																	'idDocumentType',
																	EnrollmentTypes.UserIdentificationDocumentType[
																		e.target.value
																	],
																	false
																);
																// handleChange(
																// 	(values.idDocumentType =
																// 		EnrollmentTypes.UserIdentificationDocumentType[
																// 			e.target.value
																// 		])
																// );
															}}
															hasError={getFieldMeta('idDocumentType').error}
															errorMessage={getFieldMeta('idDocumentType').error}
														/>
													</div>

													<div>
														<Field
															component={RadioButton}
															id={CoreHelper.guid()}
															name="idDocumentType"
															labelText={'Outros'}
															inputFieldLabel=""
															value={EnrollmentTypes.UserIdentificationDocumentType.OTHER}
															isChecked={
																idDocumentType ===
																EnrollmentTypes.UserIdentificationDocumentType.OTHER
															}
															onChange={(
																e: React.ChangeEvent<HTMLInputElement>
															): void => {
																this.setState({
																	idDocumentType:
																		EnrollmentTypes.UserIdentificationDocumentType[
																			e.target.value
																		],
																});
																setFieldValue(
																	'idDocumentType',
																	EnrollmentTypes.UserIdentificationDocumentType[
																		e.target.value
																	],
																	false
																);
																// handleChange(
																// 	(values.idDocumentType =
																// 		EnrollmentTypes.UserIdentificationDocumentType[
																// 			e.target.value
																// 		])
																// );
															}}
															hasError={getFieldMeta('idDocumentType').error}
															errorMessage={getFieldMeta('idDocumentType').error}
														/>
													</div>
												</div>
											)}
										></TitleContainer>
									)}
								></TitleContainer>

								<div className="custom-widths-user">
									<Field
										component={InputField}
										inputType="text"
										name="idDocumentNumber"
										value={this.state.idDocumentNumber}
										isRequired
										inputFieldLabel={'Número de documento de identificação'} // t('label.idDocumentNumber')}
										hasError={getFieldMeta('idDocumentNumber').error}
										errorMessage={getFieldMeta('idDocumentNumber').error}
										onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
											this.setState({ idDocumentNumber: e.target.value });
											handleChange((values.idDocumentNumber = e.target.value));
										}}
									/>

									{/* <Field
										component={InputField}
										inputType="text"
										name="nif"
										value={this.state.nif}
										isRequired
										inputFieldLabel={t('label.nif')}
										hasError={getFieldMeta('nif').error}
										errorMessage={getFieldMeta('nif').error}
										onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
											this.setState({ nif: e.target.value });
											handleChange((values.nif = e.target.value));
										}}
									/> */}

									<Field
										component={InputField}
										inputType="text"
										name="shortName"
										value={this.state.shortName}
										isRequired
										inputFieldLabel={t<string>('label.shortName')}
										hasError={getFieldMeta('shortName').error}
										errorMessage={getFieldMeta('shortName').error}
										onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
											this.setState({ shortName: e.target.value });
											handleChange((values.shortName = e.target.value));
										}}
									/>
									<Field
										component={InputField}
										inputType="text"
										name="email"
										isRequired
										value={this.state.email}
										inputFieldLabel={t<string>('label.email')}
										hasError={getFieldMeta('email').error}
										errorMessage={getFieldMeta('email').error}
										onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
											this.setState({ email: e.target.value });
											handleChange((values.email = e.target.value));
										}}
									/>
									{/* <div className="custom-width"> */}
									<div className="form2">
										<Field
											value={this.state.phonePrefix}
											component={InputField}
											inputType="text"
											name="phonePrefix"
											isRequired
											hasError={getFieldMeta('phonePrefix').error}
											placeholder={t<string>('label.phonePrefix')}
											errorMessage={getFieldMeta('phonePrefix').error}
											inputFieldLabel={t<string>('label.phone')}
											onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
												this.setState({ phonePrefix: e.target.value });
												handleChange((values.phonePrefix = e.target.value));
											}}
										/>

										<Field
											component={InputField}
											inputType="text"
											name="phone"
											hasError={getFieldMeta('phone').error}
											errorMessage={getFieldMeta('phone').error}
											value={this.state.phone}
											onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
												this.setState({ phone: e.target.value });
												handleChange((values.phone = e.target.value));
											}}
										/>
									</div>
								</div>

								<div className="bottom-88px" style={{ marginTop: '3.75rem' }}>
									{/* <div className="bottom-88px" style={{ marginTop: '5.5rem' }}> */}
									<TitleContainer
										text={t('titleContainer.registerPharmacy.access')}
										content={(): React.ReactNode => (
											<div className="ds-form-radio-horizontal radios-2-inline">
												<div>
													<Field
														component={RadioButton}
														id={CoreHelper.guid()}
														value={EnrollmentTypes.UserProfile.AUTHORIZED}
														labelText={signer}
														name="profileAccess"
														tooltip={(): React.ReactNode => (
															<Popup
																trigger={
																	<img
																		className="tooltip-icon"
																		src={theme.image.tooltipIcon}
																		alt=""
																	/>
																}
																content={t<string>('popups.profileAccess.signer')}
																position="bottom left"
															/>
														)}
														isChecked={
															this.state.profileAccess ===
															EnrollmentTypes.UserProfile.AUTHORIZED
														}
														hasError={getFieldMeta('profileAccess').error}
														errorMessage={getFieldMeta('profileAccess').error}
														inputFieldLabel=""
														onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
															this.setState({
																profileAccess:
																	EnrollmentTypes.UserProfile[e.target.value],
															});
															setFieldValue(
																'profileAccess',
																EnrollmentTypes.UserProfile[e.target.value],
																false
															);
															handleChange(
																(values.profileAccess =
																	EnrollmentTypes.UserProfile[e.target.value])
															);
														}}
													/>
												</div>

												<div>
													<Field
														component={RadioButton}
														id={CoreHelper.guid()}
														value={EnrollmentTypes.UserProfile.OPERATOR}
														labelText={operator}
														name="profileAccess"
														tooltip={(): React.ReactNode => (
															<>
																<Popup
																	trigger={
																		<img
																			className="tooltip-icon"
																			src={theme.image.tooltipIcon}
																			alt=""
																		/>
																	}
																	content={t<string>('popups.profileAccess.operator')}
																	position="bottom left"
																/>
															</>
														)}
														isChecked={
															this.state.profileAccess ===
															EnrollmentTypes.UserProfile.OPERATOR
														}
														// hasError={getFieldMeta('profileAccess').error}
														// errorMessage={getFieldMeta('profileAccess').error}
														inputFieldLabel=""
														onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
															this.setState({
																profileAccess:
																	EnrollmentTypes.UserProfile[e.target.value],
															});
															setFieldValue(
																'profileAccess',
																EnrollmentTypes.UserProfile[e.target.value],
																false
															);
															handleChange(
																(values.profileAccess =
																	EnrollmentTypes.UserProfile[e.target.value])
															);
														}}
													/>
												</div>
											</div>
										)}
									></TitleContainer>
								</div>

								<div className="bottom-88px">
									<TitleContainer
										text={t('titleContainer.registerPharmacy.documentation')}
										content={(): React.ReactNode => (
											<>
												<div className="file-field-div">
													<Field
														component={FileField}
														name="identificationFile"
														isRequired
														buttonText={t<string>('buttons.general.select')}
														fileFieldLabel={t<string>('label.documentId')}
														hasError={getFieldMeta('identificationFile').error}
														errorMessage={t('errors.form.required')}
														filesList={
															isEditMode && identificationDocumentFile
																? [
																		{
																			id: '',
																			name: identificationDocumentFile.fileName,
																		},
																		// identificationDocumentFile,
																  ]
																: undefined
														}
														filesMaxSize={FileUploadConfig.maxFileSizeBytes}
														showAttachmentSizeInfoModal={(text: string): void => {
															modalOpen(
																BuildOkInfoModal(
																	t(text, {
																		maxSize: FileUploadConfig.maxFileSizeMegaBytes,
																	}),
																	'Ok'
																)
															);
														}}
														showAttachmentsNumberInfoModal={(text: string): void => {
															modalOpen(
																BuildOkInfoModal(t(text, { maxNumber: 1 }), 'Ok')
															);
														}}
														nrAllowedFiles={1}
														fileId={1}
														handleFile={(file: TemporaryFile, action: FileAction): void => {
															// eslint-disable-nest-line no-debugger
															// handle our handle change with all info and formik setFieldValue
															this.handleFileChange(
																file,
																action,
																values.identificationFile,
																'identificationFile',
																setFieldValue
															);
															// this.handleChange(
															// 	file,
															// 	'identificationFile',
															// 	setFieldValue
															// );
														}}
													/>
												</div>
											</>
										)}
									></TitleContainer>
								</div>

								<div className="buttons-inline bottom-88px">
									<Button
										primary
										text={isEditMode ? 'Guardar' : t<string>('buttons.userData.newUser')}
										disabled={isSubmitting}
										type="submit"
									/>

									{!isEditMode && (
										<Button
											tertiary
											text={t('general.button.cancel')}
											onClick={event => {
												event.preventDefault();
												onClickCancel && onClickCancel();
											}}
										/>
									)}

									<Button
										tertiary
										onClick={event => {
											event.preventDefault();
											onClickBack(undefined);
										}}
										// onClick={onClickBack}
										text={t<string>('buttons.general.back')}
									/>
								</div>
								{/* </div> */}
							</FieldsFormContainer>
						</Form>
					)}
				</Formik>
				{/* </div>
			</div> */}
			</PageScreen>
		);
	}
}

const mapStateToProps = (state: StoreState): object => ({
	processFlow: getProcessFlow(state),
	usersDataList: getUsersData(state),
});

const mapDispatchToProps = (dispatch: Dispatch): object =>
	bindActionCreators({ saveUserData, updateUserData, fetchUploadFileExecutionRequest, modalOpen }, dispatch);

export default WithCoreProps<RegisterUserDataProps>(
	connect(mapStateToProps, mapDispatchToProps)(RegisterUserDataScreen)
);
